/** @jsxImportSource @emotion/react */
import React from 'react'
import { FoundersForm, FoundersPreview } from '../../../components/templates'
import * as styles from '../index.styles'
import Provider from '../../../context/FoundersContext'
import { breadcrumbItems } from '../../utils'

const { index, contentManagement, foundersManagement } = breadcrumbItems

const EnterprisesCreate: React.FC = () => {
  return (
    <Provider>
      <div css={styles.root}>
        <div css={styles.main}>
          <FoundersForm />
        </div>
        <div css={styles.right}>
          <FoundersPreview />
        </div>
      </div>
    </Provider>
  )
}

export default EnterprisesCreate;
